import { render } from "./PagePoster.vue?vue&type=template&id=44bdeac0"
import script from "./PagePoster.vue?vue&type=script&lang=js"
export * from "./PagePoster.vue?vue&type=script&lang=js"

import "./PagePoster.vue?vue&type=style&index=0&id=44bdeac0&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__